<template>
    <v-row
        class="date-range-start ma-0 pa-0"
        :class="{ 'date-range-start--card': card_layout }"
    >
        <v-col cols="6" class="date-range-start__col">
            <v-menu
            ref="start_date_picker"
            v-model="start_date_picker"
            :close-on-content-click="false"
            :return-value.sync="s_date"
            transition="scale-transition"
            offset-y
            left
            min-width="auto"
            >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                class="toolbar_selector"
                v-model="s_date"
                label="Start Date"
                :prepend-icon="card_layout ? null : 'mdi-calendar'"
                :prepend-inner-icon="card_layout ? 'mdi-calendar' : null"
                :outlined="card_layout"
                :hide-details="card_layout"
                readonly
                v-bind="attrs"
                v-on="on"
                ></v-text-field>
            </template>
            <v-date-picker
                v-model="s_date"
                :min="min_start_date"
                :max="max_end_date"
                no-title
                scrollable
                color="black"
                >
                <v-spacer></v-spacer>
                <v-btn
                class="toolbar_date_btn"
                text
                color="primary"
                @click="start_date_picker = false"
                >
                Cancel
                </v-btn>
                <v-btn
                class="toolbar_date_btn"
                text
                color="primary"
                @click="$refs.start_date_picker.save(s_date)"
                >
                OK
                </v-btn>
            </v-date-picker>
            </v-menu>
        </v-col>
        
        <v-col cols="6" class="date-range-start__col">
            <v-menu
            ref="end_date_picker"
            v-model="end_date_picker"
            :close-on-content-click="false"
            :return-value.sync="e_date"
            transition="scale-transition"
            offset-y
            left
            min-width="auto"
            >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                class="toolbar_selector"
                v-model="e_date"
                label="End Date"
                :prepend-icon="card_layout ? null : 'mdi-calendar'"
                :prepend-inner-icon="card_layout ? 'mdi-calendar' : null"
                :outlined="card_layout"
                :hide-details="card_layout"
                readonly
                v-bind="attrs"
                v-on="on"
                disabled
                ></v-text-field>
            </template>
            <v-date-picker
                v-model="e_date"
                :min="min_start_date"
                :max="max_end_date"
                no-title
                scrollable>
                <v-spacer></v-spacer>
                <v-btn
                class="toolbar_date_btn"
                text
                color="primary"
                @click="end_date_picker = false"
                >
                Cancel
                </v-btn>
                <v-btn
                class="toolbar_date_btn"
                text
                color="primary"
                @click="$refs.end_date_picker.save(e_date)"
                >
                OK
                </v-btn>
            </v-date-picker>
            </v-menu>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'DateRangeStart',
    props: [
        'start_date',
        'end_date',
        'min_start_date',
        'max_end_date',
        'card_layout',
    ],
    mounted(){
    },
    computed: {
      dateRangeText () {
        return this.date_range.join(' ~ ')
      },
    },
    data: () => ({
        start_date_picker: false,
        end_date_picker: false,
        date_range_picker: false,
        s_date: null,
        e_date: null,
        date_range: []
    }),
    methods: {
        commit_date_range: function(){
            this.$emit('date_update',this.date_range);
        }
    },
    watch: {
        // date_range: {
        //     immediate: false,
        //     handler: function (newVal, oldVal) {
        //         if(oldVal != null){
        //             this.$emit('date_update',newVal);
        //         }
        //     }
        // },
        s_date: {
            immediate: false,
            handler: function (newVal, oldVal) {
                if(oldVal != null){
                    this.$emit('start_date_update',newVal);
                }
            }
        },
        e_date: {
            immediate: false,
            handler: function(newVal, oldVal){
                if(oldVal != null){
                    this.$emit('end_date_update',newVal);
                }
            },
        },
        start_date: {
            immediate: true,
            handler: function () {
                this.s_date = this.start_date;
                this.date_range = [this.start_date, this.end_date];
            },
        },
        end_date: {
            immediate: true,
            handler: function () {
                this.e_date = this.end_date;
                this.date_range = [this.start_date, this.end_date];
            },
        }
    },
}
</script>

<style scoped>
    .toolbar_date_btn{
        font-family: 'Poppins';
        font-weight: 600;
    }

    .date-range-start--card {
        column-gap: 16px;
        display: flex;
        flex-wrap: nowrap;
    }

    .date-range-start--card .date-range-start__col {
        flex: 1 1 0;
        max-width: none;
        padding: 0;
    }

    .date-range-start--card .date-range-start__col + .date-range-start__col {
        margin-left: 16px;
    }

    .date-range-start--card ::v-deep .v-input__slot {
        min-height: 76px;
    }

    .date-range-start--card ::v-deep .v-text-field__slot input {
        font-family: "Poppins" !important;
        font-size: 1rem;
        font-weight: 500;
    }

    .date-range-start--card ::v-deep .v-label {
        font-family: "Poppins" !important;
    }
</style>
